import { render } from "./Toggle.vue?vue&type=template&id=58167226"
import script from "./Toggle.vue?vue&type=script&lang=js"
export * from "./Toggle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Toggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58167226"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58167226', __exports__)) {
    api.reload('58167226', __exports__)
  }
  
  module.hot.accept("./Toggle.vue?vue&type=template&id=58167226", () => {
    api.rerender('58167226', render)
  })

}


export default __exports__